var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconvr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 15,
    viewBox: "0 0 30 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9783 5.75821C20.1056 5.8825 20.1693 6.03786 20.1693 6.22429C20.1693 6.41071 20.1056 6.56952 19.9783 6.70071C19.851 6.825 19.6954 6.88714 19.5114 6.88714H17.973V5.57179H19.5114C19.6954 5.57179 19.851 5.63393 19.9783 5.75821Z",
    fill: "#646464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4878 0C2.45697 0 0 2.39847 0 5.35714V9.64286C0 12.6015 2.45697 15 5.4878 15H24.5122C27.543 15 30 12.6015 30 9.64286V5.35714C30 2.39847 27.543 0 24.5122 0H5.4878ZM6.76573 3.94571L9.35451 11.0714H12.0706L14.6488 3.94571H12.251L10.7762 8.71H10.7338L9.26963 3.94571H6.76573ZM22.1957 7.31179C22.4362 6.95964 22.5564 6.56607 22.5564 6.13107C22.5564 5.7375 22.461 5.375 22.27 5.04357C22.0861 4.70524 21.8067 4.4394 21.4318 4.24607C21.064 4.04583 20.6184 3.94571 20.095 3.94571H15.6283V11.0714H17.973V8.47179H18.843L20.1374 11.0714H22.7686L21.1454 8.08857C21.6051 7.92286 21.9552 7.66393 22.1957 7.31179Z",
    fill: "#646464"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconvr);
export default __webpack_public_path__ + "static/media/icon.vr.99d1e3819db9070598dcb2c6b04b1861.svg";
export { ForwardRef as ReactComponent };